// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7472":"dad27275","8280":"dad27275","9011":"dad27275"}[chunkId] + ".chunk.css";
};